import { render, staticRenderFns } from "./icon-homeoffice.vue?vue&type=template&id=7230b4d2&scoped=true"
var script = {}
import style0 from "./icon-homeoffice.vue?vue&type=style&index=0&id=7230b4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7230b4d2",
  null
  
)

export default component.exports